import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import useStore, { selectCountryTheme } from '@/hooks/client/useStore';

const css = {
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
  },
};

/**
 * The custom element that shows when a page is loading.
 * @returns {JSX.Element}
 */
const LoadingOverlay = () => {
  const countryTheme = useStore(selectCountryTheme);
  return (
    <Box sx={css.loading}>
      <CircularProgress sx={{ color: countryTheme.navColor }} size={55} disableShrink />
    </Box>
  );
};

export default LoadingOverlay;
